import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=4ba946f5&scoped=true&"
import script from "./Join.vue?vue&type=script&lang=js&"
export * from "./Join.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba946f5",
  null
  
)

export default component.exports